export { DMS_MODULE } from '../constants';

export const NAME = 'PrevzetiHodnoty';
export const CRUMB_LABEL_KEY = 'fltgrdFakturaceProfil';
